export enum LogoutBtn {
  OIAM = 'OIAM',
  HIDE = 'HIDE',
  SHOW = 'SHOW'
}
